import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4a631c86")

_pushScopeId("data-v-4a631c86")
const _hoisted_1 = { class: "element-flip" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 垂直翻转")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 水平翻转")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconFlipVertically = _resolveComponent("IconFlipVertically")
  const _component_CheckboxButton = _resolveComponent("CheckboxButton")
  const _component_IconFlipHorizontally = _resolveComponent("IconFlipHorizontally")
  const _component_CheckboxButtonGroup = _resolveComponent("CheckboxButtonGroup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_CheckboxButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_CheckboxButton, {
          style: {"flex":"1"},
          checked: _ctx.flip.x === 180,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateFlip({ x: _ctx.flip.x === 180 ? 0 : 180, y: _ctx.flip.y })))
        }, {
          default: _withId(() => [
            _createVNode(_component_IconFlipVertically),
            _hoisted_2
          ]),
          _: 1
        }, 8, ["checked"]),
        _createVNode(_component_CheckboxButton, {
          style: {"flex":"1"},
          checked: _ctx.flip.y === 180,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateFlip({ x: _ctx.flip.x, y: _ctx.flip.y === 180 ? 0 : 180 })))
        }, {
          default: _withId(() => [
            _createVNode(_component_IconFlipHorizontally),
            _hoisted_3
          ]),
          _: 1
        }, 8, ["checked"])
      ]),
      _: 1
    })
  ]))
})